import _styled from "styled-components";
import { useMemo } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { ChatBubbleLeftRightIcon, DevicePhoneMobileIcon, EllipsisHorizontalIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { customImageLoader, useResponsiveBreakPoints } from '@restworld/utils-common';
import { Dropdown } from '@restworld/ui-ds-base';
import { Title } from '../title';
import { LinkBase } from '../link-base';
import { ButtonV2 } from '../button-v2';
import IconButton from '../icon-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RestworldManagerCard(_ref) {
  var iconUrl = _ref.iconUrl,
      email = _ref.email,
      name = _ref.name,
      surname = _ref.surname,
      phoneNumber = _ref.phoneNumber,
      openIntercom = _ref.openIntercom;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isMobile = _useResponsiveBreakPo.isMobile;

  var actionItems = useMemo(function () {
    return [{
      label: t('call_the_manager'),
      Icon: DevicePhoneMobileIcon,
      href: "tel:".concat(phoneNumber)
    }, {
      label: t('send_an_email'),
      Icon: EnvelopeIcon,
      href: "mailto:".concat(email)
    }];
  }, [email, phoneNumber, t]);
  return /*#__PURE__*/_jsxs(MainWrapper, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(_StyledDiv, {
        children: [/*#__PURE__*/_jsxs(ImageAndNameWrapper, {
          children: [/*#__PURE__*/_jsx(ImageWrapper, {
            children: iconUrl && /*#__PURE__*/_jsx(Image, {
              src: iconUrl,
              alt: "",
              fill: true,
              loader: customImageLoader
            })
          }), /*#__PURE__*/_jsx(Title, {
            fontSize: "base",
            fontWeight: "semibold",
            textColor: "neutral-700",
            children: "".concat(name, " ").concat(surname)
          })]
        }), isMobile && /*#__PURE__*/_jsx(Dropdown, {
          placement: "top-end",
          items: actionItems,
          triggerElement: /*#__PURE__*/_jsx(IconButton, {
            Icon: EllipsisHorizontalIcon,
            ariaLabel: "view more",
            size: "sm"
          })
        })]
      }), phoneNumber && /*#__PURE__*/_jsx(LinkBase, {
        newTab: false,
        link: "tel:".concat(phoneNumber),
        twStyle: {
          "display": "none",
          "@media (min-width: 768px)": {
            "display": "block"
          }
        },
        children: /*#__PURE__*/_jsx(Title, {
          icon: "DevicePhoneMobileIcon",
          textColor: "neutral-200",
          fontSize: "base",
          fontWeight: "medium",
          wrapperStyle: {
            "marginBottom": "0.75rem",
            "width": "fit-content"
          },
          children: phoneNumber
        })
      }), email && /*#__PURE__*/_jsx(LinkBase, {
        newTab: false,
        link: "mailto:".concat(email),
        twStyle: {
          "display": "none",
          "@media (min-width: 768px)": {
            "display": "block"
          }
        },
        children: /*#__PURE__*/_jsx(Title, {
          icon: "EnvelopeIcon",
          textColor: "neutral-200",
          fontSize: "base",
          fontWeight: "medium",
          wrapperStyle: {
            "width": "fit-content"
          },
          children: email
        })
      })]
    }), /*#__PURE__*/_jsx(ButtonV2, {
      StartIcon: ChatBubbleLeftRightIcon,
      variant: isMobile ? 'secondary-neutral' : 'tertiary',
      fullwidth: true,
      onClick: openIntercom,
      size: "sm",
      children: t('open_chat')
    })]
  });
}
export default RestworldManagerCard;

var MainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "restworld-manager-card__MainWrapper",
  componentId: "sc-1dti5vr-0"
})(["", ""], {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "gap": "2rem",
  "borderRadius": "0.75rem",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(244 250 192 / var(--tw-bg-opacity))",
  "padding": "1.25rem",
  "@media (min-width: 768px)": {
    "borderWidth": "1px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  }
});

var ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "restworld-manager-card__ImageWrapper",
  componentId: "sc-1dti5vr-1"
})(["", ""], {
  "position": "relative",
  "height": "2rem",
  "width": "2rem",
  "overflow": "hidden",
  "borderRadius": "9999px"
});

var ImageAndNameWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "restworld-manager-card__ImageAndNameWrapper",
  componentId: "sc-1dti5vr-2"
})(["", ""], {
  "marginBottom": "0.75rem",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "flexDirection": "row"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "restworld-manager-card___StyledDiv",
  componentId: "sc-1dti5vr-3"
})({
  "display": "flex",
  "alignItems": "flex-start",
  "justifyContent": "space-between"
});